import axios from 'axios'

export const getToken = () => {
  return axios.get('/api/v1/cas/authcode').then(res => res.data)
}

export const login = (username, password, vcode) => {
  return axios.post('/api/v1/cas/login', {
    username,
    password,
    vcode
  }).then(res => res.data)
}


// WEBPACK FOOTER //
// ./src/api/api.js